// Wunschliste Button Component
class WishlistButton extends HTMLElement {
  constructor() {
    super();
    this.customerId = this.getAttribute('customer-id');
    this.isLoggedIn = this.getAttribute('is-logged-in') === 'true';
    this.productData = JSON.parse(this.getAttribute('product-data') || '{}');
    this.isInWishlist = false;
    
    this.render();
    this.addEventListener('click', this.toggleWishlist.bind(this));
    
    // Wunschliste-Status beim Laden prüfen (nur für eingeloggte User)
    if (this.customerId && this.isLoggedIn && window.wishlistClient) {
      this.checkWishlistStatus();
    }
  }

  render() {
    this.innerHTML = `
      <button type="button" class="wishlist-button" aria-label="Zur Wunschliste hinzufügen">
        <svg class="wishlist-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
        </svg>
      </button>
    `;
  }

  async checkWishlistStatus() {
    if (!window.wishlistClient || !this.customerId) return;
    
    try {
      this.isInWishlist = await window.wishlistClient.isInWishlist(this.customerId, this.productData.id);
      this.updateButton();
    } catch (error) {
      console.error('Error checking wishlist status:', error);
    }
  }

  // Snackbar anzeigen
  showSnackbar(message) {
    // Entferne vorhandenes Snackbar falls vorhanden
    const existingSnackbar = document.querySelector('.wishlist-snackbar');
    if (existingSnackbar) {
      existingSnackbar.remove();
    }

    // Erstelle neues Snackbar
    const snackbar = document.createElement('div');
    snackbar.className = 'wishlist-snackbar';
    snackbar.textContent = message;
    
    document.body.appendChild(snackbar);
    
    // Animation: Einblenden
    setTimeout(() => {
      snackbar.classList.add('show');
    }, 10);
    
    // Animation: Nach 2s ausblenden und entfernen
    setTimeout(() => {
      snackbar.classList.add('hide');
      snackbar.classList.remove('show');
      
      setTimeout(() => {
        if (snackbar.parentNode) {
          snackbar.remove();
        }
      }, 300);
    }, 2000);
  }

  async toggleWishlist(event) {
    event.preventDefault();
    event.stopPropagation();
    
    // Wenn nicht eingeloggt, Snackbar anzeigen
    if (!this.isLoggedIn || !this.customerId) {
      this.showSnackbar('Bitte einloggen um die Wunschliste benutzen zu können');
      return;
    }

    // Loading-Status anzeigen
    try {
      this.classList.add('loading');
      
      if (this.isInWishlist) {
        // Aus Wunschliste entfernen
        const success = await window.wishlistClient.removeFromWishlist(this.customerId, this.productData.id);
        if (success) {
          this.isInWishlist = false;
          this.classList.remove('is-active');
          console.log('Produkt aus Wunschliste entfernt:', this.productData.title);
        }
      } else {
        // Zur Wunschliste hinzufügen
        const success = await window.wishlistClient.addToWishlist(this.customerId, this.productData);
        if (success) {
          this.isInWishlist = true;
          this.classList.add('is-active');
          console.log('Produkt zur Wunschliste hinzugefügt:', this.productData.title);
        }
      }
      
      this.updateButton();
      
      // Event für andere Components (z.B. Wunschliste-Counter)
      this.dispatchEvent(new CustomEvent('wishlist-updated', {
        detail: { 
          productId: this.productData.id, 
          isInWishlist: this.isInWishlist,
          productData: this.productData
        }
      }));
      
    } catch (error) {
      console.error('Error toggling wishlist:', error);
      // Hier könnte eine Benutzer-Benachrichtigung angezeigt werden
    } finally {
      this.classList.remove('loading');
    }
  }

  updateButton() {
    const button = this.querySelector('.wishlist-button');
    const icon = this.querySelector('.wishlist-icon');
    
    if (this.isInWishlist) {
      // Gefülltes Herz (in Wunschliste)
      button.classList.add('is-active');
      icon.setAttribute('fill', 'currentColor');
      button.setAttribute('aria-label', 'Von Wunschliste entfernen');
    } else {
      // Leeres Herz (nicht in Wunschliste)
      button.classList.remove('is-active');
      icon.setAttribute('fill', 'none');
      button.setAttribute('aria-label', 'Zur Wunschliste hinzufügen');
    }
  }
}

// Custom Element registrieren
if (!window.customElements.get('wishlist-button')) {
  window.customElements.define('wishlist-button', WishlistButton);
}

// CSS-basierte Auto-Initialisierung (DEAKTIVIERT - wird nur bei Bedarf aktiviert)
/*
document.addEventListener('DOMContentLoaded', function() {
  // Alle Elemente mit data-wishlist-button Attribut finden
  const wishlistTriggers = document.querySelectorAll('[data-wishlist-button]');
  
  wishlistTriggers.forEach(trigger => {
    // Produkt-Daten aus data-Attributen lesen
    const productData = {
      id: parseInt(trigger.dataset.productId),
      handle: trigger.dataset.productHandle,
      title: trigger.dataset.productTitle,
      image_url: trigger.dataset.productImage,
      price: trigger.dataset.productPrice
    };
    
    const customerId = trigger.dataset.customerId;
    
    // Wishlist Button Element erstellen
    const wishlistButton = document.createElement('wishlist-button');
    wishlistButton.setAttribute('customer-id', customerId);
    wishlistButton.setAttribute('product-data', JSON.stringify(productData));
    
    // CSS-Klassen übertragen
    if (trigger.className) {
      wishlistButton.className = trigger.className + ' wishlist-button-auto';
    }
    
    // Button an der gleichen Stelle einfügen
    trigger.parentNode.insertBefore(wishlistButton, trigger.nextSibling);
    
    // Optional: Original-Element verstecken oder entfernen
    if (trigger.dataset.replaceElement === 'true') {
      trigger.remove();
    } else {
      trigger.style.display = 'none';
    }
  });
});
*/